import styled from 'styled-components';
import { TextStyles } from '@mono/metui/src/utils/text-styles-selector';

const Hr = styled.hr`
    border: none;
    border-bottom: 1px solid #cdcdcd;
    width: 100%;
`;

const HeaderCell = styled.div<{ mode?: 'cozy' | 'compact' }>`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2px 0;
    white-space: nowrap;
    ${({ mode }) => TextStyles[mode ?? 'cozy'].h4}
    &:last-child {
        border-bottom: none;
    }
`;

const TableCell = styled.p<{ mode?: 'cozy' | 'compact' }>`
    flex: 1;
    justify-content: center;
    white-space: nowrap;
    margin-top: 6px;
    margin-bottom: 10px;
    width: 100%;
    ${({ mode }) => TextStyles[mode ?? 'cozy'].p}
    line-height: 24px;
`;

export { Hr, HeaderCell, TableCell };
